import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { KYMW1407ImageInfoDetailBoxModule } from '../kymw1407-image-info-detail-box/kymw1407-image-info-detail-box.module';

import { KYMW1407ImageInfoDetailComponent } from './kymw1407-image-info-detail.component';


/**
 * 画像情報詳細 モジュール設定クラス
 *
 * @export KYMW1407ImageInfoDetailModule
 * @class KYMW1407ImageInfoDetailModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW1407ImageInfoDetailBoxModule,
  ],
  declarations: [
    KYMW1407ImageInfoDetailComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW1407ImageInfoDetailComponent,
  ]
})
export class KYMW1407ImageInfoDetailModule {
}
